module.exports = __webpack_public_path__ + "img/pic_3.61b08dac.jpg";